import React, { Suspense } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from '@shared/config';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export const ACTIVATION_SUCCESS_PAGE_PATH = '/activation/success';

const Renderer = React.lazy(() => import('./renderer'));

const ActivationSuccessPageWrapper: IApplicationPage = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

ActivationSuccessPageWrapper.config = {
  routes: [
    {
      path: ACTIVATION_SUCCESS_PAGE_PATH,
    },
  ],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default ActivationSuccessPageWrapper;
